import { ref, computed, watchEffect } from 'vue';
import Request from '@/services/request';
import { GET_PRODUCTS } from '../../utils/enum/endpoints';

const Req = new Request();

const DEFAULT_PAGE_COUNT = -1;
const DEFAULT_RESULT_COUNT = -1;

export default function useService(pagination, payload) {
  const data = ref(null);
  const totalResultCount = ref(DEFAULT_RESULT_COUNT);
  const error = ref(null);
  const isLoading = ref(false);
  const request = ref(null);
  const nextCursor = ref(null);
  const prevCursor = ref(null);

  const requestParams = computed(() => {
    const { pageSize } = pagination.value;

    return {
      pageSize: pageSize.toString(),
    };
  });

  const pageCount = computed(() => {
    const { pageSize } = pagination.value;

    return Math.ceil(totalResultCount.value / pageSize);
  });

  watchEffect(() => {
    const payloadData = payload.value;
    // checking if excel export triggered.
    if (typeof payloadData.brandNameList === 'object') {
      return;
    }

    isLoading.value = true;

    if (!payloadData.pageRequest || !payloadData.tabParam) {
      return;
    }

    Object.keys(payloadData).forEach((key) => {
      if (payloadData[key] === '') {
        payloadData[key] = null;
      }
    });
    const tabParam = payloadData.tabParam;
    request.value = Req.post(
      `${GET_PRODUCTS.replace('{tabParam}', encodeURIComponent(tabParam))}`,
      {
        ...payloadData,
        pageRequest: {
          sortOrders: null,
          ...requestParams.value,
        },
      },
    )
      .then(async (response) => {
        if (response.status === 200) {
          data.value = response.data.content;
          nextCursor.value = response.data.nextCursor;
          prevCursor.value = response.data.prevCursor;
          error.value = null;
          totalResultCount.value =
            response.data.totalElements ?? DEFAULT_PAGE_COUNT;
        } else {
          throw new Error('Network response was not OK');
        }
      })
      .catch((err) => {
        error.value = err || null;
        data.value = null;
        totalResultCount.value = DEFAULT_PAGE_COUNT;
      })
      .finally(() => {
        isLoading.value = false;
      });
  });

  return {
    data,
    nextCursor,
    prevCursor,
    totalResultCount,
    pageCount,
    error,
    isLoading,
  };
}
